// extracted by mini-css-extract-plugin
export var alignLeft = "l_pL d_fn d_bF d_dt";
export var alignCenter = "l_bN d_fp d_bC d_dv";
export var alignRight = "l_pM d_fq d_bG d_dw";
export var customRow = "l_pF d_bC d_Y";